
export const appReducer = (state, action) => {
  var nState = state;
  switch (action.type) {
    case 'LOGIN':
      nState = Object.assign({}, state, {CurrentUser: action.data, loginTime: (new Date()).getTime()});
      break;
    case 'LOGOUT':
      localStorage.removeItem("contextData");
      nState =  Object.assign({}, state, {CurrentUser: null, loginTime: null});
      break;
    case 'SET_MESSAGE':
      nState =  Object.assign({}, state, {Message: action.data});
      break;
    case 'CLEAR_MESSAGE':
      nState =  Object.assign({}, state, {Message: null});
      break;
    case 'SET_THEME':
      nState =  Object.assign({}, state, {CurrentTheme: action.data});
      break;
    default:
      return state;
  }

  localStorage.setItem("contextData", JSON.stringify(nState));
  return nState;
} 